import * as React from "react";
import styled from "styled-components";
import { IntegrationItem } from "../../../types/StateTypes";
import { theme } from "../../../utils/theme";
import { AppText } from "../../UI";
import { ConnectSwitch } from "./ConnectSwitch";

interface ConnectButtonProps {
  integration: IntegrationItem;
  isConnected: boolean;
  disabled?: boolean;
  tooltipText?: string;
  onChange: (checked: boolean) => void;
}

const ConnectButton: React.FC<ConnectButtonProps> = ({ integration, isConnected, disabled, tooltipText, onChange }) => {
  return (
    <ConnectDiv isConnected={isConnected}>
      <ConnectSwitch
        item={integration}
        isConnected={isConnected}
        disabled={disabled}
        tooltipText={tooltipText}
        onChange={onChange}
      />
      <AppText fontSize={12} fontWeight={500}>
        {isConnected ? "Connected" : "Connect"}
      </AppText>
    </ConnectDiv>
  );
};

const ConnectDiv = styled.div<{ isConnected: boolean }>`
  padding: 12px;
  background-color: ${({ isConnected }) => (isConnected ? theme.fill.brand.secondary : theme.fill.neutral.secondary)};
  border: ${({ isConnected }) =>
    isConnected ? `1px solid ${theme.border.brand.tertiary}` : `1px solid ${theme.border.neutral.secondary}`};
  width: fit-content;
  display: flex;
  flex-direction: row;
  gap: 8px;
  border-radius: 8px;
`;

export { ConnectButton };
